import api from 'axios'
import { URL_BACK } from '../../variableProd'
/**
 * Servicio para autenticación y administración de Colaboradores
 * @module ServicioColaboradores
 */
const getLayout  = URL_BACK + '/pagos/getLayout.php'
const sendData  = URL_BACK + '/pagos/sendData.php'
const getStatics  = URL_BACK + '/pagos/getStatics.php'
const getFilePdf  = URL_BACK + '/pagos/getFilePdf.php'
const getFileXml  = URL_BACK + '/pagos/getFileXml.php'

/**
 * Funciones para autenticación y administración de usuarios.
 */

export default {
  /**
   * Colaboradores
   * @param {object} model - Modelo de Enviar datos de layout
   * @returns {Promise} Promesa que se resuelve con la respuesta del servidor.
   * @throws {Error} Si ocurre un error durante la solicitud.
   */
  getLayout(model) {
  return new Promise((resolve, reject) => {
    api
      .post(getLayout, model, {
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(response => {
        // Crear descarga automática
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'LAYOUT_PLUGIN_PAGOSv3.xlsx');
        document.body.appendChild(link);
        link.click();
        link.remove();

        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
  
  },
  sendData(model) {
  {
    return new Promise((resolve, reject) => {
      api
        .post(sendData, model)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
  },
  getStatics(model) {
  {
    return new Promise((resolve, reject) => {
      api
        .post(getStatics, model)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
  },
  getFilePdf(model) {

  return api.post(getFilePdf, model, {
    responseType: 'blob',
    headers: {
      'Content-Type': 'application/json'
    }
  })
  .then(response => {

    const blob = new Blob([response.data], { type: 'application/pdf' });

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");

    a.href = url;
    a.download = model.uuid + ".pdf";

    document.body.appendChild(a);
    a.click();
    a.remove();

    window.URL.revokeObjectURL(url);

  });

  },
  getFileXml(model) {

    return api.post(getFileXml, model, {
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(response => {

      const blob = new Blob([response.data], { type: 'application/xml' });

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");

      a.href = url;
      a.download = model.uuid + ".xml";

      document.body.appendChild(a);
      a.click();
      a.remove();

      window.URL.revokeObjectURL(url);

    });

  }
}
